<template>
  <div>
    <SearchableTable
      :panel-header="'Kassen'"
      :panel-route="'AddBalanceGroup'"
      :show-search-bar="false"
      :table-data="balanceGroups"
      :table-meta-data="tableMetaData"
      :query-string="'setPersonSearchQuery'"
    >
      <b-table-column
        v-slot="props"
        label="Aktionen"
        cell-class="has-text-right truncate-column"
        header-class="th-right truncate-column"
      >
        <b-button
          class="is-small mr-2"
          @click="triggerView(props.row)"
        >
          <b-icon
            class="mt-1"
            icon="eye"
            style="cursor: pointer"
          />
        </b-button>
        <b-button
          class="is-small mr-2"
          @click="triggerEdit(props.row)"
        >
          <b-icon
            class="mt-1"
            icon="pencil"
            style="cursor: pointer;"
          />
        </b-button>
        <b-button
          class="is-small"
          @click="triggerDelete(props.row)"
        >
          <b-icon
            class="mt-1"
            icon="delete"
            style="cursor: pointer"
          />
        </b-button>
      </b-table-column>
    </SearchableTable>
    <b-modal v-model="isDeleteCheck">
      <div
        v-if="isDeleteCheck"
        class="panel m-5"
        style="background-color: white"
      >
        <p class="panel-heading">
          Möchtest du
          "{{ chosenBalanceGroup.attributes.name }}" wirklich
          löschen?
        </p>
        <div
          class="buttons mt-2"
          style="display: flex; justify-content: center"
        >
          <b-button
            class="is-danger"
            :loading="isLoading"
            @click="submitDelete()"
          >
            Ja
          </b-button>
          <b-button
            class="is-primary"
            @click="() => isDeleteCheck = false"
          >
            Nein
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SearchableTable from "../../helperComponents/SearchableTable.vue";
import Parse from "parse/dist/parse.min"

export default {
	name: "BalanceComponent",
	components: { SearchableTable },
	data() {
		return {
			balanceGroups: [],
			isDeleteCheck: false,
			chosenBalanceGroup: undefined,
			isLoading: false,
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Name", "field": "name", "sortField": "attributes.name" }
			]
		}
	},
	async mounted() {
		await this.query()
	},
	updated() {
		// this.query()
	},
	methods: {
		async query() {
			const query = new Parse.Query("BalanceGroup").notEqualTo("deleted", true).include("budgets");
			this.balanceGroups = await query.find()
		},
		triggerEdit(balanceGroup) {
			this.$router.push({ name: "AddBalanceGroup", params: { balanceGroup: balanceGroup } });
		},
		triggerDelete(balanceGroup) {
			this.chosenBalanceGroup = balanceGroup
			this.isDeleteCheck = true
		},
		triggerView(balanceGroup) {
			this.$router.push({ name: "ViewBalanceGroup", params: { balanceGroup: balanceGroup } });
		},
		submitDelete() {
			this.chosenBalanceGroup.set("deleted", true)
			for (const budget of this.chosenBalanceGroup.attributes.budgets) {
				budget.set("deleted", true)
				budget.save()
			}
			this.chosenBalanceGroup.save().then(() => {
				this.isDeleteCheck = false
				this.query()
			})
		}
	}
}
</script>

<style scoped></style>
